module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-injekcni-metody_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/laserova-estetika/vyhlazeni-vrasek-injekcni-metody_2_before.jpg
// module id = 1020
// module chunks = 0